var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      class: { translucid: _vm.translucid },
      attrs: {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", [
        _c("path", {
          attrs: {
            d:
              "M1.65954 0.000165435L15.9998 14.3404L14.3403 16L0 1.65971L1.65954 0.000165435Z",
            fill: _vm.color
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M0.00017724 14.3403L14.3405 0L16 1.65954L1.65972 15.9998L0.00017724 14.3403Z",
            fill: _vm.color
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }